import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-label", "aria-expanded"];
const _hoisted_2 = {
  class: "app-nav-menu",
  "aria-label": "Guest menu"
};
const _hoisted_3 = {
  class: "app-nav-menu__icon app-nav-menu__icon--gold",
  "aria-hidden": "true"
};
const _hoisted_4 = {
  class: "app-nav-menu__label"
};
const _hoisted_5 = {
  class: "app-nav-menu__icon app-nav-menu__icon--green",
  "aria-hidden": "true"
};
const _hoisted_6 = {
  class: "app-nav-menu__label"
};
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { Trophy, Coin } from '@element-plus/icons-vue';
import AppNavLocalePicker from '@/components/nav/AppNavLocalePicker.vue';
export default {
  __name: 'AppNavGuestMenu',
  emits: ['switch-locale'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      locale
    } = useI18n();
    const router = useRouter();
    const open = ref(false);
    const menuPlacement = computed(() => locale.value === 'ar' ? 'bottom-start' : 'bottom-end');
    function go(path) {
      open.value = false;
      router.push(path);
    }
    function onSwitchLocale(code) {
      emit('switch-locale', code);
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createBlock(_component_el_popover, {
        visible: open.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => open.value = $event),
        placement: menuPlacement.value,
        width: 300,
        trigger: "click",
        "show-arrow": false,
        "popper-class": "app-nav-menu-popper"
      }, {
        reference: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["app-nav__hamburger", {
            'is-open': open.value
          }]),
          "aria-label": _ctx.$t('nav.mobileMenuOpen'),
          "aria-expanded": open.value
        }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, line => {
          return _createElementVNode("span", {
            key: line,
            class: "app-nav__hamburger-line"
          });
        }), 64))], 10, _hoisted_1)]),
        default: _withCtx(() => [_createElementVNode("nav", _hoisted_2, [_createElementVNode("button", {
          type: "button",
          class: "app-nav-menu__row",
          onClick: _cache[0] || (_cache[0] = $event => go('/leagues'))
        }, [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Trophy))]),
          _: 1
        })]), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('nav.leaderboard')), 1)]), _createElementVNode("button", {
          type: "button",
          class: "app-nav-menu__row",
          onClick: _cache[1] || (_cache[1] = $event => go('/referrals'))
        }, [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Coin))]),
          _: 1
        })]), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('nav.rewards')), 1)]), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "app-nav-menu__divider"
        }, null, -1)), _createElementVNode("button", {
          type: "button",
          class: "app-nav-menu__text-link",
          onClick: _cache[2] || (_cache[2] = $event => go('/help'))
        }, _toDisplayString(_ctx.$t('siteFooter.support.helpCenter')), 1), _createElementVNode("button", {
          type: "button",
          class: "app-nav-menu__text-link",
          onClick: _cache[3] || (_cache[3] = $event => go('/help/doc/terms'))
        }, _toDisplayString(_ctx.$t('helpPage.docs.terms.title')), 1), _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "app-nav-menu__divider"
        }, null, -1)), _createVNode(AppNavLocalePicker, {
          onSwitchLocale: onSwitchLocale
        })])]),
        _: 1
      }, 8, ["visible", "placement"]);
    };
  }
};